import Historicos from "../containers/Historicos";
import Login from "../containers/Login";
import Pendientes from "../containers/Pendientes";

const routes = [
  {
    path: "/auth/login",
    component: Login,
    title: "Portal Médico",
    needsAuth: false,
  },
  {
    path: "/pendientes",
    component: Pendientes,
    title: "DIM | Principal",
    needsAuth: true,
  },
  {
    path: "/historicos",
    component: Historicos,
    title: "DIM | Principal",
    needsAuth: true,
  },
  {
    path: "/",
    component: Login,
    title: "Portal Médico",
    needsAuth: false,
  },
];

export default routes;